import { WWGNews } from "./WWGNews";

export default WWGNews;
